export const postMessages = {
  "cs": {
    "posts.title": "Příspěvky",
    "posts.empty": "Zatím tu nejsou žádné příspěvky pro vás.",
    "posts.loading": "Načítání příspěvků…",
    "posts.error": "Příspěvky se nepodařilo načíst.",
    "posts.retry": "Zkusit znovu",
    "posts.more": "Načíst další",
    "posts.end": "To jsou všechny aktuální příspěvky.",
    "posts.locked": "Obsah je zamčený",
    "posts.unlock": "Získat přístup",
    "posts.memberHint": "Celý příspěvek je dostupný schváleným členům tohoto portálu.",
    "posts.planHint": "Celý příspěvek je dostupný členům s odpovídajícím aktivním plánem. O přístup požádejte správce portálu.",
    "posts.audience.public": "Všichni návštěvníci",
    "posts.audience.members": "Členové portálu",
    "posts.audience.subscribers": "Členové s aktivním plánem",
    "posts.audience.plans": "Členové s vybranými plány",
    "posts.videoTitle": "Video: {title}",
    "posts.coverAlt": "Titulní obrázek: {title}"
  },
  "en": {
    "posts.title": "Posts",
    "posts.empty": "There are no posts available to you yet.",
    "posts.loading": "Loading posts…",
    "posts.error": "Posts could not be loaded.",
    "posts.retry": "Try again",
    "posts.more": "Load more",
    "posts.end": "You are up to date.",
    "posts.locked": "This content is locked",
    "posts.unlock": "Get access",
    "posts.memberHint": "The full post is available to approved members of this portal.",
    "posts.planHint": "The full post is available to members with an eligible active plan. Contact the portal administrator for access.",
    "posts.audience.public": "All visitors",
    "posts.audience.members": "Portal members",
    "posts.audience.subscribers": "Members with an active plan",
    "posts.audience.plans": "Members with selected plans",
    "posts.videoTitle": "Video: {title}",
    "posts.coverAlt": "Cover image: {title}"
  }
} as const;
